import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { QRCodeModule } from 'angularx-qrcode';
import { NgChartsModule } from 'ng2-charts';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxMultipleDatesModule } from 'ngx-multiple-dates';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ComponentLoaderComponent } from './utilities/components/component-loader/component-loader.component';
import { OopsComponent } from './utilities/components/oops/oops.component';
import { ToastrModule } from 'ngx-toastr';
import { DetailedErrorComponent } from './utilities/components/detailed-error/detailed-error.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerComponent } from './utilities/components/pdf-viewer/pdf-viewer.component';
import { SafeUrlPipe } from './utilities/components/pipes/safe-url.pipe';
import { MatOptionModule } from '@angular/material/core';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { TreeSelectModule } from 'primeng/treeselect';
import {MatSelectModule} from '@angular/material/select';
import { CalendarModule } from 'primeng/calendar';
@NgModule({
  declarations: [
    ComponentLoaderComponent,
    OopsComponent,
    DetailedErrorComponent,
    PdfViewerComponent,
    SafeUrlPipe
  ],
  imports: [
    ScrollingModule,
    MatExpansionModule,
    FormsModule,
    HttpClientModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    QRCodeModule,
    MatCardModule,
    MatDatepickerModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    NgxMultipleDatesModule,
    MatFormFieldModule,
    MatChipsModule,
    AutocompleteLibModule,
    NgxMaterialTimepickerModule,
    MatTabsModule,
    MatSnackBarModule,
    NgChartsModule,
    MatCheckboxModule,
    NgSelectModule,
    NgxPaginationModule,
    MatTooltipModule,
    MatProgressBarModule,
    AngularEditorModule,
    CommonModule,
    NgxExtendedPdfViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatOptionModule,
    ToastrModule.forRoot({
       maxOpened: 8,
      autoDismiss: true,
    }),
    MatDialogModule,
    TreeModule,
    ButtonModule,
    TreeSelectModule,
    MatSelectModule,
    CalendarModule
  ],
   providers: [DatePipe,],
  exports: [
    ToastrModule,
    NgMultiSelectDropDownModule,
    ScrollingModule,
    FormsModule,
    HttpClientModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    QRCodeModule,
    MatCardModule,
    MatDatepickerModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    NgxMultipleDatesModule,
    MatFormFieldModule,
    MatChipsModule,
    AutocompleteLibModule,
    NgxMaterialTimepickerModule,
    MatTabsModule,
    MatSnackBarModule,
    NgChartsModule,
    MatCheckboxModule,
    NgSelectModule,
    NgxPaginationModule,
    MatTooltipModule,
    MatProgressBarModule,
    AngularEditorModule,
    ComponentLoaderComponent,
    NgxExtendedPdfViewerModule,
    PdfViewerComponent,
    SafeUrlPipe,
    MatOptionModule,
    TreeModule,
    ButtonModule,
    TreeSelectModule,
    MatSelectModule,
    CalendarModule
  ],
})
export class SharedModule {}
